import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import DangerousHTML from 'Components/Utility/DangerousHTML';

import 'Components/Product/ProductAboutSection/GiftCardHowToSteps.scss';

const GiftCardHowToSteps = ({ externalRedeemLink, redemptionSteps, drm }) =>
  <aside className="GiftCardHowToStepsMain">
    <h3 className="section-heading">
      <FormattedMessage
        id="giftcardhowtosteps.abouttab.title"
        defaultMessage="How to Use Your Gift Card"
      />
    </h3>

    <div className="GiftCardHowToSteps">
      <div className="GiftCardHowToSteps__step">
        <div className="GiftCardHowToSteps__step__titleContainer h5">
          <div className="GiftCardHowToSteps__step__number">1</div>
          <div className="GiftCardHowToSteps__step__title">
            <FormattedMessage id="giftcardhowtosteps.completepurchase" defaultMessage="Complete Puchase" />
          </div>
        </div>
        <div className="GiftCardHowToSteps__step__text">
          <FormattedMessage
            id="giftcardhowtosteps.chooseanamount"
            defaultMessage="Click “Add to Cart” and follow the steps through the checkout to purchase your Gift Card in just a couple of clicks."
          />
        </div>
      </div>

      <div className="GiftCardHowToSteps__step">
        <div className="GiftCardHowToSteps__step__titleContainer h5">
          <div className="GiftCardHowToSteps__step__number">2</div>
          <div className="GiftCardHowToSteps__step__title">
            <FormattedMessage id="giftcardhowtosteps.copyyourgiftcardcode" defaultMessage="Copy Your Gift Card Code" />
          </div>
        </div>
        <div className="GiftCardHowToSteps__step__text">
          <FormattedMessage id="giftcardhowtosteps.gottoyourorderdetails" defaultMessage="Go to your Order Details and copy your Gift Card code." />
        </div>
      </div>

      {externalRedeemLink && !redemptionSteps &&
        <div className="GiftCardHowToSteps__step">
          <div className="GiftCardHowToSteps__step__titleContainer h5">
            <div className="GiftCardHowToSteps__step__number">3</div>
            <div className="GiftCardHowToSteps__step__title">
              <FormattedMessage id="giftcardhowtosteps.redeem" defaultMessage="Redeem" />
            </div>
          </div>
          <div className="GiftCardHowToSteps__step__text">
            <FormattedMessage
              id="giftcardhowtosteps.visitpartner"
              defaultMessage="Visit {externalRedeemLink} to redeem your Gift Card using the code."
              values={{
                externalRedeemLink: <a href={externalRedeemLink} target="_blank" rel="noopener noreferrer nofollow" aria-label="Gift Card Redeem Link">
                  {externalRedeemLink}
                </a>,
              }}
            />
          </div>
        </div>
      }

      {redemptionSteps &&
        <div className="GiftCardHowToSteps__step">
          <div className="GiftCardHowToSteps__step__titleContainer h5">
            <div className="GiftCardHowToSteps__step__number">3</div>
            <div className="GiftCardHowToSteps__step__title">
              {drm !== 'switch' &&
                <FormattedMessage id="giftcardhowtosteps.redemption-instructions" defaultMessage="Redemption Instructions" />
              }
              {drm === 'switch' &&
                <FormattedMessage id="giftcardhowtosteps.redemption-instructions.switch" defaultMessage="Redeemable on Nintendo Switch" />
              }
            </div>
          </div>
          <DangerousHTML html={redemptionSteps} />
        </div>
      }
    </div>
  </aside>;

GiftCardHowToSteps.propTypes = {
  externalRedeemLink: PropTypes.string,
  redemptionSteps: PropTypes.string,
  drm: PropTypes.string,
};

GiftCardHowToSteps.defaultProps = {
  externalRedeemLink: '',
  redemptionSteps: '',
  drm: '',
};

export default GiftCardHowToSteps;
